import { type NavItem, MobileNav as UIMobileNav } from '@quadralize/ui'
import { Buildings2, UserId, Widget } from '@solar-icons/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useAppStore } from '@/stores/use-app-store'

export function MobileNav() {
  const { t } = useTranslation('layout')
  const navigate = useNavigate()
  const { toggleSidebar } = useAppStore()
  const currentPath = window.location.pathname

  const navItems: NavItem[] = [
    { label: t('navigation.dashboard'), icon: Widget, path: '/' },
    { label: t('navigation.companies'), icon: Buildings2, path: '/empresas' },
    { label: t('navigation.users'), icon: UserId, path: '/usuarios' },
  ]

  return (
    <UIMobileNav
      items={navItems}
      currentPath={currentPath}
      onNavigate={(path) => navigate(path)}
      onToggleMenu={toggleSidebar}
    />
  )
}
